export const ROUTES = {
  ROOT: '/shippers/:shipperId/shipments',
};
